




import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { ReferenceFileAccessibleMixin } from "../mixins";
import { ReferenceFileDialogsAccessor } from "../CommonComponentsAccessor";
import { ReferenceFileViewMixin } from "../../mixins";

@Component
export default class FileViewerAdapter extends Mixins(ModelEditableMixin, ReferenceFileAccessibleMixin, ReferenceFileViewMixin) {
  @Prop()
  dialogs: ReferenceFileDialogsAccessor;

  async openReferenceFile(): Promise<void> {
    if (this.referenceFiles.length === 1) {
      const file = this.referenceFiles[0];
      this.openReferenceFileViewer(file);
    } else if (this.referenceFiles.length > 1) {
      this.dialogs.selector.show(this.referenceFiles, f => this.openReferenceFileViewer(f));
    }
  }

}
